import LibraryTable from 'components/widgets/RenderLibraryTable/libraryTable';
import { RenderUploadFilesModal } from 'components/common/UploadFileModal/RenderUploadFilesModal';
import useUserHook from 'hooks/useUserHook';
import FileUploader from 'components/common/FileUploader/fileUploader';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { TreeProgramTopHeader } from 'components/common';
import { DropdownMenu } from 'components/common/ProgramLibraryDropdownMenu/dropdownMenu';
import { generatePath, useParams, useRouteMatch } from 'react-router-dom';
import { projectConfig } from 'components/Dashboards/Project/ProjectWrapper/projectConfig';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { ActionsSection } from 'components/common/PageContainer/actionsSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { useProjectTreeWithUrlHook } from 'components/common/TreeProgramFilter/ProjectTree/hooks/useProjectTreeWithUrlHook';
import { UploadVersionWarningModal } from 'components/common/UploadVersionWarningModal/uploadVersionWarningModal';

export const ProgramLibraryPage = () => {
    const { setParams } = useProjectTreeWithUrlHook();
    const { path } = useRouteMatch();
    const { ability } = useUserHook();
    const { projectId, contractId } = useParams<{ projectId: string; contractId: string }>();
    useFullStoryPageView({ pageName: projectConfig.programLibrary.title });
    const url = new URL(window.location.href).origin + generatePath(path, { projectId, contractId });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader
                            versionSelectorEnabled={false}
                            pageTitle={projectConfig.programLibrary.title}
                            showAll={true}
                            callback={setParams}
                        >
                            <ActionsSection>
                                <ShareInsightButton title={projectConfig.programLibrary.title} link={url} />
                                {ability.can('view', 'ManageProjects') && <DropdownMenu callback={setParams} />}
                                {ability.can('view', 'UploadVersion') && <FileUploader />}
                            </ActionsSection>
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
            </HeaderWrapper>

            <MainContent>
                <LibraryTable />
            </MainContent>

            <RenderUploadFilesModal />
            <UploadVersionWarningModal />
        </PageContainer>
    );
};
